module.exports = __webpack_public_path__ + "static/media/icon_media_add.7f692bd0.svg";